module.exports = __webpack_public_path__ + "static/media/1.2b92009a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/1.gif
// module id = 225
// module chunks = 0